module.exports = __webpack_public_path__ + "static/media/4.b725bd3d.jpg";